module.exports = __webpack_public_path__ + "img/image_upload_icon.ffc21796.svg";